<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import ButtonV4 from 'next/button/Button.vue';

const props = defineProps({
  feature: {
    type: String,
    default: '',
  },
});

const WHATSAPP_NUMBER = '5581986120862';

const featureLabels = {
  pipeline: 'Pipelines e CRM',
  calendar: 'Calendário e Agendamento',
  knowledge_base: 'Base de Conhecimento',
  ai_agents: 'Agentes de IA',
  permissions: 'Funções e Permissões',
};

const featureLabel = computed(
  () => featureLabels[props.feature] || 'este recurso'
);

const whatsappUrl = computed(() => {
  const message = encodeURIComponent(
    `Olá! Gostaria de fazer upgrade do meu plano para acessar o recurso: ${featureLabel.value}.`
  );
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
});
</script>

<template>
  <div class="w-full h-full flex items-center justify-center p-8">
    <div
      class="flex flex-col max-w-md w-full px-8 py-8 border shadow-sm bg-n-solid-1 rounded-xl border-n-weak"
    >
      <!-- Ícone + Título -->
      <div class="flex items-center gap-3 mb-4">
        <span
          class="flex items-center justify-center w-8 h-8 rounded-full bg-n-solid-blue flex-shrink-0"
        >
          <Icon icon="i-lucide-lock-keyhole" class="text-n-brand size-[16px]" />
        </span>
        <h2 class="text-base font-semibold text-n-slate-12">
          {{ $t('PIPELINE_PERMISSIONS.PAYWALL.TITLE') }}
        </h2>
      </div>

      <!-- Descrição -->
      <p class="text-sm text-n-slate-11 mb-2">
        {{
          $t('PIPELINE_PERMISSIONS.PAYWALL.DESCRIPTION', {
            feature: featureLabel,
          })
        }}
      </p>
      <p class="text-sm text-n-slate-11 mb-6">
        {{ $t('PIPELINE_PERMISSIONS.PAYWALL.CTA_HINT') }}
      </p>

      <!-- Botão WhatsApp -->
      <a :href="whatsappUrl" target="_blank" rel="noopener noreferrer">
        <ButtonV4 solid class="w-full !bg-green-500 hover:!bg-green-600">
          <Icon icon="i-lucide-message-circle" class="size-[14px] mr-1" />
          {{ $t('PIPELINE_PERMISSIONS.PAYWALL.CTA_BUTTON') }}
        </ButtonV4>
      </a>
    </div>
  </div>
</template>
